import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ContactButtons = () => {
  const handleTestClick = () => {
    window.open('https://t.me/Aidating_love_test_bot', '_blank');
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <Button
        variant="default"
        size="lg"
        onClick={handleTestClick}
        className="rounded-full w-16 h-16 shadow-2xl hover:scale-110 transition-transform bg-gradient-to-r from-primary to-accent"
      >
        <Icon name="Brain" size={28} color="white" />
      </Button>
    </div>
  );
};

export default ContactButtons;